export default __webpack_public_path__ + "static/media/assets.faee3990.png";